// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a.SidebarItem__wrapper {
    text-decoration: none;
}

a.SidebarItem__wrapper .SidebarItem{
    width: 100%;
}

.SidebarItem {
    border: none;
    background: none;
    text-decoration: none;
    font-size: 100%;
    padding: 0.858rem 0.858rem 0.858rem 1.43rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: var(--palette-gray-6);
    cursor: pointer;
}

.Sidebar.Sidebar--collapsed .SidebarItem {
    padding: 0.858rem;
    justify-content: center;
}

.SidebarItem:hover,
a.SidebarItem__wrapper:hover {
    text-decoration: none;
    font-weight: 500;
}

.SidebarItem:hover:not(.SidebarItem--active) {
    background-color: var(--unknown-grey-to-review-dadce0);
}

.SidebarItem:hover,
.SidebarItem:hover .SvgIcon {
    color: var(--palette-text);
}

.SidebarItem .SvgIcon {
    color: var(--palette-gray-8);
    height: 24px;
    width: 24px;
}

.SidebarItem span:not(.SvgIcon) {
    margin-left: 0.71rem;
    text-transform: uppercase;
}

.SidebarItem--active {
    font-weight: 500;
}

.SidebarItem--active, .SidebarItem--active .SvgIcon {
    color: var(--palette-menu-active);
}

.SidebarItem--active:hover, 
.SidebarItem--active:hover .SvgIcon {
    color: var(--palette-menu-active);
}

/* this overrides main.scss style '.new-style button:hover' */
.new-style button.SidebarItem:hover {
    opacity: 1;
}`, "",{"version":3,"sources":["webpack://./js/components/Sidebar/SidebarItem.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,2CAA2C;IAC3C,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;;IAEI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA,6DAA6D;AAC7D;IACI,UAAU;AACd","sourcesContent":["a.SidebarItem__wrapper {\n    text-decoration: none;\n}\n\na.SidebarItem__wrapper .SidebarItem{\n    width: 100%;\n}\n\n.SidebarItem {\n    border: none;\n    background: none;\n    text-decoration: none;\n    font-size: 100%;\n    padding: 0.858rem 0.858rem 0.858rem 1.43rem;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    color: var(--palette-gray-6);\n    cursor: pointer;\n}\n\n.Sidebar.Sidebar--collapsed .SidebarItem {\n    padding: 0.858rem;\n    justify-content: center;\n}\n\n.SidebarItem:hover,\na.SidebarItem__wrapper:hover {\n    text-decoration: none;\n    font-weight: 500;\n}\n\n.SidebarItem:hover:not(.SidebarItem--active) {\n    background-color: var(--unknown-grey-to-review-dadce0);\n}\n\n.SidebarItem:hover,\n.SidebarItem:hover .SvgIcon {\n    color: var(--palette-text);\n}\n\n.SidebarItem .SvgIcon {\n    color: var(--palette-gray-8);\n    height: 24px;\n    width: 24px;\n}\n\n.SidebarItem span:not(.SvgIcon) {\n    margin-left: 0.71rem;\n    text-transform: uppercase;\n}\n\n.SidebarItem--active {\n    font-weight: 500;\n}\n\n.SidebarItem--active, .SidebarItem--active .SvgIcon {\n    color: var(--palette-menu-active);\n}\n\n.SidebarItem--active:hover, \n.SidebarItem--active:hover .SvgIcon {\n    color: var(--palette-menu-active);\n}\n\n/* this overrides main.scss style '.new-style button:hover' */\n.new-style button.SidebarItem:hover {\n    opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
